'use strict';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {NoteState} from '../../../../system/enums/NoteState';
import {Button} from '../../../../components/buttons/Button';
import {ProgressBar} from '../../../../components/ProgressBar';


const NOTE_CLASS = {0: 'error', 1: 'progress', 2: 'indefinite', 3: 'complete', 4: 'info'};

export class NotificationItemView extends Component {

  constructor(props) {
    super(props);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleAction = this.handleAction.bind(this);
  }

  handleRemove(e) {
    if (isFunction(this.props.onRemove)) {
      this.props.onRemove(e, this.props.note);
    }
  }

  handleAction(e) {
    const props = this.props;
    if (props.note.actions && isObject(props.note.actions[props.note.__noteState])) {
      const action = props.note.actions[props.note.__noteState];
      if (isFunction(action.handler)) {
        action.handler();
      }
    }
  }

  render() {
    const props = this.props;
    const showMessage = NotificationItemView.showMessage(props);
    const showProgress = NotificationItemView.showProgress(props);
    return (
      <div
        className={classNames("NotificationItem card", NOTE_CLASS[props.note.__noteState], props.className)}
      >
        <div className="NotificationItem__left left-section">
          <div
            className={classNames("NotificationItem__title", {
              NotificationItem__title_padding: showMessage || showProgress,
            })}
          >
            {props.note.name}
          </div>
          {showMessage ? NotificationItemView.renderMessage(props) : null}
          {showProgress ? NotificationItemView.renderProgress(props) : null}
        </div>
        {NotificationItemView.renderActions(props, this.handleAction)}
        <div className="NotificationItem__right right-section">
          <Button
            className="NotificationItem__remove"
            iconClass={props.note.__noteState === NoteState.COMPLETE ? "swift-complete" : "ion-android-close"}
            onClick={this.handleRemove}
          />
        </div>
      </div>
    );
  }

  static renderMessage(props) {
    const isError = props.note.__noteState === NoteState.ERROR;
    return (
      <div
        className={classNames("NotificationItem__message", {
          NotificationItem__message_error: isError,
        })}
      >
        {isError ? <i className="icon ion-alert-circled" /> : null}
        <span>
          {props.note.message}
        </span>
      </div>
    );
  }

  static showMessage(props) {
    switch (props.note.__noteState) {
      case NoteState.ERROR:
      case NoteState.INFO:
      case NoteState.COMPLETE:
        return !!props.note.message;
      default:
        return false;
    }
  }

  static renderProgress(props) {
    return (
      <ProgressBar
        isIndefinite={props.note.__noteState === NoteState.INDEFINITE}
        progress={props.note.progress}
      />
    );
  }

  static showProgress(props) {
    return props.note.__noteState === NoteState.PROGRESS || props.note.__noteState === NoteState.INDEFINITE;
  }

  static renderActions(props, onAction) {
    if (props.note.actions && isObject(props.note.actions[props.note.__noteState])) {
      const action = props.note.actions[props.note.__noteState];
      return (
        <div className="NotificationItem__actions">
          <Button
            className={action.className}
            label={action.label}
            onClick={onAction}
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

NotificationItemView.propTypes = {
  className: T.string,
  note: T.shape({
    __noteState: T.number,
    name: T.string.isRequired,
    message: T.string,
    progress: T.number,
    actions: T.object,
  }).isRequired,

  onRemove: T.func,
};

NotificationItemView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/core-utilities/notifications/components/NotificationItem/NotificationItemView.js